export default "__VITE_ASSET__DFC3uJvV__"